import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { useQuery } from '@tanstack/react-query';
import { PackingStationsApiAdapter } from '../adapters/PackingStationsApiAdapter';
import { PackingStationDetail } from '../models/PackingStation';
import { Service } from '../services/Service';

export const usePackingStationDetail = (id: number | null, initialDetail: PackingStationDetail | null = null) => {
  const httpClient = createHttpClient(apiClientWH);
  const apiAdapter = new PackingStationsApiAdapter(httpClient);
  const service = new Service(apiAdapter);

  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['packing-station-detail', id],
    queryFn: () => service.getById(id!),
    enabled: id !== null && !initialDetail,
    staleTime: 1 * 60 * 1000, // 1 minuto
    gcTime: 5 * 60 * 1000,
  });

  return {
    detail: data ?? initialDetail,
    isLoading,
    error,
    refetch,
  };
};
